/**
 * 판정 기록 상세 — styled.
 * @spec:2026-09-29-처방검토-판정기록-조회화면
 */
import styled from "styled-components";
import { COLOR_SYSTEM } from "components/design/design-system";

export const Head = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border: 1px solid ${COLOR_SYSTEM.get("Gray")?.[100]};
  border-radius: 12px;
`;

export const HeadItem = styled.div`
  font-size: 13px;
  color: ${COLOR_SYSTEM.get("Gray")?.[800]};
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const SectionTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${COLOR_SYSTEM.get("Gray")?.[800]};
`;

export const ListName = styled.span`
  font-size: 12px;
  color: ${COLOR_SYSTEM.get("Gray")?.[500]};
  margin-left: 6px;
`;

export const StateBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 48px 0;
  font-size: 14px;
  color: ${COLOR_SYSTEM.get("Gray")?.[700]};
`;

export const Nav = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const NavButtons = styled.div`
  display: flex;
  gap: 8px;
`;

export const VersionLine = styled.div`
  font-size: 12px;
  color: ${COLOR_SYSTEM.get("Gray")?.[600]};
  margin-bottom: 4px;
`;
